<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-if="source" class="svg-icon" v-html="source"></div>
</template>

<script>
  export default {
    name: 'svg-icon-component',
    props: {
      source: {
        type: String,
        required: false,
        default: '',
      },
    },
    data() {
      return {};
    },
  };

</script>
